import ChatInput from 'modules/conversation/components/ChatInput/ChatInput.js'

export default ChatInput
